(() => {
  const root = document.querySelector('[data-spectral-home]');
  if (!root) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hero = root.querySelector('.spectral-home__hero-media');

  // Reveal sections when they approach the viewport.
  const revealItems = root.querySelectorAll('.spectral-home__section > .page-width');
  if ('IntersectionObserver' in window && !prefersReduced) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          const transition = entry.target.parentElement?.nextElementSibling;
          if (transition?.classList.contains('spectral-home__transition')) {
            transition.classList.add('is-visible');
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -10% 0px' });
    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  if (prefersReduced || !hero) return;

  // Desktop pointer interaction: subtle camera shift + a soft light hotspot.
  if (window.matchMedia('(pointer:fine)').matches) {
    let raf = 0;
    let px = 50;
    let py = 50;

    const render = () => {
      raf = 0;
      hero.style.setProperty('--spot-x', `${px}%`);
      hero.style.setProperty('--spot-y', `${py}%`);
      const x = (px - 50) * 0.055;
      const y = (py - 50) * 0.035;
      hero.style.transform = `translate3d(${x}px, ${y}px, 0) scale(1.018)`;
    };

    const move = (event) => {
      px = (event.clientX / window.innerWidth) * 100;
      py = (event.clientY / window.innerHeight) * 100;
      if (!raf) raf = requestAnimationFrame(render);
    };

    const leave = () => {
      px = 50;
      py = 50;
      if (!raf) raf = requestAnimationFrame(render);
    };

    window.addEventListener('pointermove', move, { passive: true });
    root.addEventListener('pointerleave', leave, { passive: true });
  }

  // Make anchor navigation feel deliberate rather than an abrupt jump.
  root.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const id = link.getAttribute('href');
      const target = id && document.querySelector(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
